export default __webpack_public_path__ + "static/media/light_2_placeholder.54286382.jpg";